import { selector } from 'recoil';
import _ from 'lodash';
import { multiPanelAtom, panelStartIndexAtom, lastActivePanelIdAtom, reloadListTicketKnowleadPanel } from '@/state/atom/panelAtom';
import Utils from '@/common/utils/utils';
import PanelUtils from '@/common/utils/PanelUtils';
import Constant from '@/common/constant/Constant';
import { addPanel } from '@/component/multiPanel/panel/handler/PanelHandler';
import DetailTicket from '@/component/chatThread/DetailTicket';
import DetailTicketKnowledge from '@/component/ticketKnowledge/DetailTicketKnowledge';
import DetailTicketDraft from '@/component/ticketList/DetailTicketDraft';
import {userAtom} from '@/state/atom/userAtom';
import DetailEmailTicket from '@/component/ticketList/emailTicket/DetailEmailTicket';

/**
 * Get panel default by selector
 */
export const setPanelSelector = selector({
    key: 'setPanelSelector',
    get: props => ({ get }) => {
        let panelList = [];
        const defaultPanelState = get(multiPanelAtom);

        if (Utils.isEmptyArray(defaultPanelState)) {
            const defaultPanel = addPanel(Constant.PANEL_TYPE.LIST_TICKET, props);
            panelList.push(defaultPanel);
        } else {
            panelList = [...defaultPanelState];
        }
        return panelList;
    },
    set: ({ get, set }, data) => {
        // 
        let windowScreenWidth = window.screen.width;
        let currentPanelList = get(multiPanelAtom);
        currentPanelList = !Utils.isEmptyArray(currentPanelList) ? currentPanelList : [];
        // console.log('currentPanelList', currentPanelList);

        let startPanelIndex = get(panelStartIndexAtom);
        let userDetail = get(userAtom);

        let newPanelList = _.cloneDeep(currentPanelList);

        let fromPanelId = data.currentPanelId ? data.currentPanelId : data.props?.panelId;

        // panel id start relate

        // open relate panel type 
        let openRelatePanelType = data?.openRelatePanelType
        // console.log('namnhdebug data', data)

        let openPanelType = data.type;
        let openPanelTabId = data.tabId;
        let existedKnowledgePanel = data?.existedKnowledgePanel
        // let openFromType = data?.openFromType;

        let isAddNewPanelFromMenu = typeof fromPanelId === 'undefined' ? true : false;
        // console.log('namnhdebug newPanelList', newPanelList)
        if (openPanelType !== Constant.PANEL_TYPE.OPEN_CHAT_AI) {
            const openAiPanelIndex = newPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.OPEN_CHAT_AI);
            if (openAiPanelIndex >= 0) {
                let openAiPanel = newPanelList[openAiPanelIndex];
                if (!openAiPanel?.isDisplay && openAiPanelIndex !== newPanelList.length - 1) {
                    newPanelList.splice(openAiPanelIndex, 1);
                    newPanelList.push(openAiPanel);
                }
            }
        }
    
        // check panel exist
        let openPanelIndex = newPanelList.findIndex(panel => panel.type === openPanelType);



        // thực tế sẽ bị sai
        let currentPanelIndex = currentPanelList.findIndex(panel => panel.id === fromPanelId); // todo
        let fromPanelData = currentPanelList.find(panel => panel.id === fromPanelId)
        if (!fromPanelData) {
            fromPanelData = currentPanelList[currentPanelList.length - 1];
        }
        if (!fromPanelId && currentPanelList.length > 0) {
            fromPanelId = currentPanelList[currentPanelList.length - 1].id;
        }

        let isAddNewTab = false;
        let openTabIndex;
        let isOpenPanelAi = false;

        // existed panel
        // console.log('namnhdebug openPanelIndex :>> ', openPanelIndex);
        if (openPanelIndex >= 0) {
            if (openPanelType === Constant.PANEL_TYPE.OPEN_CHAT_AI && !newPanelList[openPanelIndex]?.isDisplay) {

                // update new index for open ai panel
                newPanelList[openPanelIndex].isDisplay = true;
                const panelChatAI = newPanelList[openPanelIndex];
              
                // const knowledgeListPanel = newPanelList.find(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);

                // const knowledgePanel = newPanelList.find(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
                const knowledgeListPanelIndex = newPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
                // const openAiPanelSize = panelChatAI.size;

                // console.log('namnhdebug knowledgeListPanel', {knowledgeListPanel, knowledgeListPanelIndex})

                newPanelList.splice(openPanelIndex, 1);
                newPanelList.splice(knowledgeListPanelIndex + 1, 0, panelChatAI);
                
                openPanelIndex = newPanelList.findIndex(panel => panel.type === openPanelType);
                currentPanelIndex = newPanelList.findIndex(panel => panel.type === fromPanelId);
                isAddNewPanelFromMenu = false;
                isOpenPanelAi = true;
            }

            // check tab exist
            openTabIndex = newPanelList[openPanelIndex].tabList.findIndex(
                tab => tab.id === openPanelTabId
            );
            //existed tab
            if (openTabIndex < 0) {
                isAddNewTab = true;
            }
        }

        data.isAddNewTab = isAddNewTab;
        data.openPanelId = openPanelIndex >= 0 ? newPanelList[openPanelIndex].id : null;
        data.userDetail = userDetail;
        data.selectThreadId = data?.selectThreadId || data?.props?.selectThreadId || '';


        const newPanel = addPanel(data);
        // console.log('namnhdebug newPanel :>> ', newPanel);
        
        if (Utils.isEmptyObject(newPanel)) {
            set(panelStartIndexAtom, newPanelList.length);
            return;
        }

        let currentPanelData = newPanelList[openPanelIndex];
        // console.log('namnhdebug currentPanelData :>> ', currentPanelData);


        if (currentPanelData && !Utils.isEmptyObject(currentPanelData)) {
            let currentPanelId = currentPanelData.id;
            let tabData = currentPanelData.tabList[currentPanelData.activeTab];
            let currentTabId = tabData?.id;
    
            set(lastActivePanelIdAtom, {
                panelId: currentPanelId,
                tabId: currentTabId
            });
        }

        let newStartPanelIndex = 0;

        // for mobile devices display 1 panel
        if (windowScreenWidth < (Constant.PANEL_RESPONSIVE.MOBILE + 1)) {
            if (openPanelIndex >= 0) {
                if (isAddNewTab) {
                    //add new tab
                    newPanelList[openPanelIndex].tabList.push(newPanel.tabList[0]);
                    newPanelList[openPanelIndex].activeTab =
                    newPanelList[openPanelIndex].tabList.length - 1;
                } else {
                    //active exist tab
                    newPanelList[openPanelIndex].activeTab = openTabIndex;
                }
                newStartPanelIndex = openPanelIndex;
            } else {
                newPanelList.splice(startPanelIndex + 1, 0, newPanel);
                newStartPanelIndex = getStartPanelIndexOpenNewPanelMobile(newPanelList, newPanel)
            }

            set(multiPanelAtom, newPanelList);
            set(panelStartIndexAtom, newStartPanelIndex);
            return;
        } 
        
        // for tablets
        if (windowScreenWidth > Constant.PANEL_RESPONSIVE.MOBILE && windowScreenWidth < Constant.PANEL_RESPONSIVE.PC) {
            // display 2 panel
            if (openPanelIndex >= 0) {
                if (isAddNewTab) {
                    //add new tab
                    newPanelList[openPanelIndex].tabList.push(newPanel.tabList[0]);
                    newPanelList[openPanelIndex].activeTab =
                        newPanelList[openPanelIndex].tabList.length - 1;
                } else {
                    //active exist tab
                    newPanelList[openPanelIndex].activeTab = openTabIndex;
                }

                if (
                    (openPanelIndex > startPanelIndex && startPanelIndex + 1 >= openPanelIndex) ||
                    openPanelIndex === startPanelIndex
                ) {
                    // If panel is open, reload panel common data
                    if ([Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST, Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST].includes(currentPanelData?.type)) {
                        set(reloadListTicketKnowleadPanel, currentPanelData?.id);
                    }
                } else {
                }

                set(multiPanelAtom, newPanelList);
                
            } else {
                newStartPanelIndex = startPanelIndex;

                
                if (isAddNewPanelFromMenu) {
                    // newPanelList.push(newPanel);
                    newPanelList.splice(startPanelIndex + 2, 0, newPanel);
                } else {
                    newPanelList.splice(currentPanelIndex + 1, 0, newPanel);
                }
                set(multiPanelAtom, newPanelList);
            }

            newStartPanelIndex = getStartPanelIndexOpenNewPanelTablet(openPanelIndex, newPanelList, newPanel, startPanelIndex, isAddNewPanelFromMenu);
            set(panelStartIndexAtom, newStartPanelIndex);

            return;
        } 


        // display 3 panel
        // ---------------------------- open exited panel -----------------------------
        if (openPanelIndex >= 0) {
            // console.log('openPanelIndex', openPanelIndex)
            let tabIdxOfData;
            if (isAddNewTab) {
                //add new tab
                newPanelList[openPanelIndex].tabList.push(newPanel.tabList[0]);
                newPanelList[openPanelIndex].activeTab =
                    newPanelList[openPanelIndex].tabList.length - 1;
            } else {
                //active exist tab
                newPanelList[openPanelIndex].activeTab = openTabIndex;
                tabIdxOfData = newPanelList[openPanelIndex].tabList?.findIndex(
                    tab => tab?.id === data?.ticketId
                );
                if (tabIdxOfData !== -1) {
                    newPanelList[openPanelIndex].tabList[
                        tabIdxOfData
                    ].component.props.selectThreadId = data?.selectThreadId;
                    newPanelList[openPanelIndex].tabList[
                        tabIdxOfData
                    ].component.props.triggerReload = Date.now();
                } 
            }

            newStartPanelIndex = PanelUtils.calculateIndexOpenExistPanel(currentPanelData, startPanelIndex, newPanelList, isOpenPanelAi, isAddNewTab);

            if (openRelatePanelType) {
                const openRelatePanelTypeIndex = newPanelList.findIndex(panel => panel.type === openRelatePanelType);
                let isBringPanelCloseTogether = PanelUtils.checkBringPanelCloseTogether(newPanelList, openRelatePanelType, openPanelIndex);
                let openIndexPanel = newPanelList[openPanelIndex];
                if (isBringPanelCloseTogether) {
                    // console.log('--- before Bring newPanelList', newPanelList)

                    // newPanelList.splice(openPanelIndex, 1);
                    // newPanelList.splice(openRelatePanelTypeIndex + 1, 0, openIndexPanel);

                    // openPanelIndex = openRelatePanelTypeIndex + 1
                    // startPanelIndex = openRelatePanelTypeIndex

                    const removedPanel = newPanelList.splice(openPanelIndex, 1)[0];
                    const insertIndex = openRelatePanelTypeIndex < openPanelIndex ? openRelatePanelTypeIndex + 1 : openRelatePanelTypeIndex;
                    newPanelList.splice(insertIndex, 0, removedPanel);

                    // console.log('--- after Bring newPanelList', newPanelList)
                }
                   
                newStartPanelIndex = PanelUtils.caculateIndexPanelRelateExist(startPanelIndex, openRelatePanelType, newPanelList, openPanelIndex, openIndexPanel, isBringPanelCloseTogether);
                // console.log('namnhdebug caculateIndexPanelRelateExist newStartPanelIndex', {startPanelIndex, newStartPanelIndex})
            }

            if (data?.props?.targetTicketIdOfChatPost && tabIdxOfData !== -1) {
                newPanelList[openPanelIndex].tabList[
                    tabIdxOfData
                ].component.props.targetTicketIdOfChatPost = data?.props?.targetTicketIdOfChatPost;
            }

            set(multiPanelAtom, newPanelList);
            set(panelStartIndexAtom, newStartPanelIndex);
            return;
        }

        // console.log('isAddNewPanelFromMenu', isAddNewPanelFromMenu)
        newStartPanelIndex = startPanelIndex;
        if (isAddNewPanelFromMenu) {
            let startSliceIndex = startPanelIndex;
            if (openPanelType === Constant.PANEL_TYPE.OPEN_CHAT_AI) {
                const knowledgeListPanelIndex = newPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
                startSliceIndex = knowledgeListPanelIndex
            } 

            let caculateResult = caculateIndexOpenFromMenu(startPanelIndex, newPanelList, newPanel);
            // console.log('namnhdebug FromMenu result', caculateResult)
            
            let insertIndex = caculateResult.insertIndex;
            newStartPanelIndex = caculateResult.newStartPanelIndex;
            
            newPanelList.splice(startSliceIndex + insertIndex, 0, newPanel);
            // console.log('namnhdebug FromMenu newPanelList', newPanelList)

        } else {
            // console.log('namnhdebug FromOtherPanel caculate', {
            //     startPanelIndex, newPanelList, newPanel, fromPanelData
            // })

            let caculateResult = caculateIndexOpenFromOtherPanel(startPanelIndex, newPanelList, newPanel, fromPanelData);
            // console.log('namnhdebug FromOtherPanel result', caculateResult)
            
            const fromPanelIndex = caculateResult.fromPanelIndex;
            newStartPanelIndex = caculateResult.newStartPanelIndex;

            let isUpdateIndex = true;
            if (openPanelType === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST) {
                const openAiIndex = newPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.OPEN_CHAT_AI);
                const openAiPanel = newPanelList.find(panel => panel.type === Constant.PANEL_TYPE.OPEN_CHAT_AI);
                if (openAiPanel?.isDisplay && existedKnowledgePanel) {
                    newPanelList.splice(openAiIndex - 1, 0, newPanel);
                    isUpdateIndex = false;
                }
            } 
            // trường hợp mở từ panel khác, sẽ push new panel vào bên cạnh
            if (isUpdateIndex) newPanelList.splice(fromPanelIndex + 1, 0, newPanel);

        }

        if (openRelatePanelType) {
            newStartPanelIndex = PanelUtils.caculateIndexPanelRelate(startPanelIndex, openRelatePanelType, newPanelList);
            // console.log('namnhdebug caculateIndexPanelRelate openRelatePanelType :>> ', {startPanelIndex, newStartPanelIndex} );
        }
        
        if (openPanelIndex < 0) {
            const targetPanelIdx = newPanelList?.findIndex(panel => panel?.id === newPanel?.id);
            const tabIdxOfData = newPanelList[targetPanelIdx].tabList?.findIndex(
                tab => tab?.id === data?.ticketId
            );
            
            if (tabIdxOfData !== -1) {
                const componentPanel = _.cloneDeep(newPanelList[targetPanelIdx].tabList[tabIdxOfData].component);
                // assign data props to open chat panel chat. by share link ticket. 
                if (
                    [
                        Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD,
                        Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
                        Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD
                    ].includes(newPanelList[targetPanelIdx]?.type)
                ) {
                    newPanelList[targetPanelIdx].tabList[tabIdxOfData].component = {
                        ...componentPanel,
                        props: {
                            ...componentPanel.props,
                            ...data
                        }
                    };
                }
            }
        }

        set(multiPanelAtom, newPanelList);
        if (newStartPanelIndex !== startPanelIndex)  set(panelStartIndexAtom, newStartPanelIndex);
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent'
    }
});

export const updatePanelSelector = selector({
    key: 'updatePanelSelector',
    get: (props) =>
        ({ get }) => {
            
        },
    set: ({ get, set }, data) => {
        let currentPanelList = get(multiPanelAtom);
        
        let newPanelList = _.cloneDeep(currentPanelList);
        let openPanelIndex = currentPanelList.findIndex((panel) => panel.type === data.panelType);

        let currentPanelData = newPanelList[openPanelIndex];
        let currentpanelId = currentPanelData.id;
        let tabData = currentPanelData.tabList[currentPanelData.activeTab];
        let currentTabId = tabData.id;

        // update 
        newPanelList[openPanelIndex].activeTab = data.activeTab;
        set(multiPanelAtom, newPanelList);
        set(lastActivePanelIdAtom, {
            panelId: currentpanelId,
            tabId: currentTabId
        });
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent',
    },
});

export const updatePanelAfterCreateTicketSelector = selector({
    key: 'updatePanelAfterCreateTicketSelector',
    get: (props) =>
        ({ get }) => {
            
        },
    set: ({ get, set }, data) => {
        let currentPanelList = get(multiPanelAtom);
        let newPanelList = _.cloneDeep(currentPanelList);

        let openPanelIndex = newPanelList.findIndex((panel) => panel.id === data.panelId);

        if (openPanelIndex == -1) {
            openPanelIndex = newPanelList.findIndex((panel) => panel.type === data.panelType);
        }
        let tabIndex = newPanelList[openPanelIndex].tabList.findIndex(tab =>
            tab.id === data.tabId || tab.tabId === data.tabId
        );

        let newDetailTicketComponent = <DetailTicket 
            componentName={"DetailTicket"}
            API={data.API}
            panelId={data.panelId} 
            ticketId={data.ticketId}
            panelType={data.panelType}
            ticketOutline={data.ticketOutline}
            tabId={data.tabId}
        />

        if (data.panelType === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL) {
            newDetailTicketComponent = (
                <DetailTicketKnowledge
                    componentName={'DetailTicketKnowledge'}
                    API={data.API}
                    panelId={data.panelId}
                    ticketId={data.ticketId}
                    panelType={data.panelType}
                    ticketOutline={data.ticketOutline}
                    tabId={data.ticketId}
                />
            );
        }
        if (data.isDraft) {
            newDetailTicketComponent = (
                <DetailTicketDraft
                    componentName={Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT}
                    API={data.API}
                    panelId={data.panelId}
                    ticketId={data.ticketId}
                    panelType={data.panelType}
                    ticketOutline={data.ticketOutline}
                    tabId={data.ticketId}
                    isDraft={true}
                    isTicketDeleted={data.isTicketDeleted}
                    triggerReload = {Date.now().toString()}
                />
            );
        }
        if (data?.isEmailTicket) {
            newDetailTicketComponent = ( <DetailEmailTicket 
                componentName={Constant.COMPONENT_NAME.DETAIL_TICKET_EMAIL}
                API={data.API}
                panelId={data.panelId}
                ticketId={data.ticketId}
                panelType={data.panelType}
                ticketOutline={data.ticketOutline}
                tabId={data.ticketId}
                isDetailEmailTicket={true}
                isEmailTicket={true}
            />)
        }

        newPanelList[openPanelIndex].tabList[tabIndex].component = newDetailTicketComponent;
        newPanelList[openPanelIndex].tabList[tabIndex].id = data.ticketId;
        newPanelList[openPanelIndex].tabList[tabIndex].ticketOutline = data.ticketOutline;
        newPanelList[openPanelIndex].tabList[tabIndex].tabId = data.ticketId;
        newPanelList[openPanelIndex].tabList[tabIndex].isDraft = data.isDraft;
        newPanelList[openPanelIndex].tabList[tabIndex].isEmailTicket = data.isEmailTicket;
        newPanelList[openPanelIndex].tabList[tabIndex].isTicketDeleted = data.isTicketDeleted;

        // update tab ticket children after restored delete
        if (!Utils.isEmptyArray(data.updatedChildrenTicketIdList) && !data.isTicketDeleted) {
            const childrenTicketIdList = [...data.updatedChildrenTicketIdList]
            childrenTicketIdList.forEach(childTicketId => {
                const openingTicketIndex = newPanelList[openPanelIndex].tabList.findIndex(t => t.id === childTicketId);
                if (openingTicketIndex !== -1) {
                    newPanelList[openPanelIndex].tabList[openingTicketIndex].isTicketDeleted = false;
                }
            })
        }

        // update threadChat if is opening
        let chatThreadPanelIndex = newPanelList.findIndex((panel) => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD);
        if (chatThreadPanelIndex !== -1) {
            let tabChatList = newPanelList[chatThreadPanelIndex].tabList;
            let chatThreadTabIndex = tabChatList.findIndex(tab => tab.id === data.ticketId);
            if (chatThreadTabIndex !== -1) {
                data.deletedAt ?
                    newPanelList[chatThreadPanelIndex].tabList[chatThreadTabIndex].isTicketDeleted = true
                    : newPanelList[chatThreadPanelIndex].tabList[chatThreadTabIndex].isTicketDeleted = false;

                newPanelList[chatThreadPanelIndex].tabList[chatThreadTabIndex].component.props.triggerReload = Date.now().toString();
            }
        }


        let indexPanelCsv = newPanelList.findIndex(
            p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
        );

        if(indexPanelCsv !== -1 && data.tabId === newPanelList[indexPanelCsv].tabList[0]?.id) {
            newPanelList[indexPanelCsv].tabList[0].id = data.ticketId;
        }

        //reload related panel list ticket
        let relatedPanelType = "helpdesk_ticket_list";
        if(data.panelType.includes("customer")){
            relatedPanelType = "customer_ticket_list";
        }
        if(data.panelType.includes("knowledge")){
            relatedPanelType = "knowledge_ticket_list";
        }
        let relatedPanelIndex = newPanelList.findIndex((panel) => panel.type === relatedPanelType);
        if(relatedPanelIndex >= 0){
            newPanelList[relatedPanelIndex].tabList[0].component.props.triggerReload = Date.now().toString();
        }

        // If add ticket, reload drilldown
        if (data.tabId && data.tabId.includes(Constant.PANEL_TYPE.KNOWLEDGE_CREATE_TICKET)) {
            // let drillDownHelpdeskPanelType = Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_DRILLDOWN_AND_DETAIL_SEARCH;
            let drillDownPrjInusePanelType = Constant.PANEL_TYPE.KNOWLEDGE_PRJ_INUSE_DRILLDOWN_AND_DETAIL_SEARCH;
            let drillDownPrjInusePanelIndex = newPanelList.findIndex((panel) => panel.type === drillDownPrjInusePanelType);
            if (drillDownPrjInusePanelIndex > -1) {
                newPanelList[drillDownPrjInusePanelIndex].tabList[0].component.props.triggerReload = Date.now().toString();
            }
        }

        set(multiPanelAtom, newPanelList);
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent',
    },
});

export const closePanelTabSelector = selector({
    key: 'closePanelTabSelector',
    get: (props) =>
        ({ get }) => {
            
        },
    set: ({ get, set }, params) => {
        const {event, isCloseMulti, closeList, isRemovePanel} = params;
        if(event !== null){
            event.stopPropagation();
        }
        let currentPanelList = get(multiPanelAtom);
        let newPanelList = _.cloneDeep(currentPanelList);
        if (isCloseMulti && !Utils.isEmptyArray(closeList)) {
            for (const panelClose of closeList) {
                newPanelList = removeTabAndPanel(_.cloneDeep(newPanelList), panelClose.panelType, panelClose.tabId, isRemovePanel);
            }
        } else {
            newPanelList = removeTabAndPanel(newPanelList, params.panelType, params.tabId, isRemovePanel);
        }
        // console.log('currentPanelList', currentPanelList.length);
        // console.log('newPanelList', newPanelList.length);
        // has remove panel
        if (currentPanelList.length > newPanelList.length) {
            const startPanelIndex = get(panelStartIndexAtom);
            let newPanelListClone = _.cloneDeep(newPanelList);
            newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);
            let newStartPanelIndex = 0;
            if (!newPanelListClone[startPanelIndex]) {
                // focus to last panel
                
                if (newPanelListClone.length > 0) {
                    const lastPanelIndex = newPanelListClone.length - 1;
                    newStartPanelIndex = PanelUtils.caculatePanelIndexInScreenView(lastPanelIndex, newPanelList)
                    // console.log('--- caculatePanelIndexInScreenView2 newStartPanelIndex', newStartPanelIndex)
                    //     const lastPanel = newPanelListClone[lastPanelIndex];
                    //     const preLastPanel = newPanelListClone[lastPanelIndex - 1]
                    //     const pre2LastPanel = newPanelListClone[lastPanelIndex - 2]
                    //     newStartPanelIndex = lastPanelIndex;
                    //     // if last panel size 3 focus to lastPanelIndex
                    //     // if last panel size = 2
                    //     if (lastPanel?.size === Constant.PANEL_SIZE.SIZE_2) {
                    //         if (preLastPanel?.size === Constant.PANEL_SIZE.SIZE_1) {
                    //             newStartPanelIndex = lastPanelIndex -1;
                    //         }
                    //     }

                    //     if (lastPanel?.size === Constant.PANEL_SIZE.SIZE_1) {
                    //         if (pre2LastPanel?.size === Constant.PANEL_SIZE.SIZE_1 && preLastPanel?.size === Constant.PANEL_SIZE.SIZE_1) {
                    //             newStartPanelIndex = lastPanelIndex - 2
                    //         }

                    //         if (preLastPanel?.size === Constant.PANEL_SIZE.SIZE_1 || preLastPanel?.size === Constant.PANEL_SIZE.SIZE_2) {
                    //             newStartPanelIndex = lastPanelIndex - 1
                    //         }
                    //     }
                    
                }
               
            } else {
                newStartPanelIndex = PanelUtils.caculatePanelIndexInScreenView(startPanelIndex, newPanelList)
                // console.log('--- caculatePanelIndexInScreenView newStartPanelIndex', newStartPanelIndex)
            }
            
            if (newStartPanelIndex >= 0 && newStartPanelIndex !== startPanelIndex)   set(panelStartIndexAtom, newStartPanelIndex);
            
        }
        set(multiPanelAtom, newPanelList);
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent',
    },
});

export const triggerReloadTicketListByPanelType = selector({
    key: 'triggerReloadTicketListByPanelType',
    get: (props) =>
        ({ get }) => {
            
        },
    set: ({ get, set }, data) => {
        let currentPanelList = get(multiPanelAtom);
        let newPanelList = _.cloneDeep(currentPanelList);
        let openPanelIndex = newPanelList.findIndex((panel) => panel.type === data.panelType);
        if (openPanelIndex === -1) return;
        newPanelList[openPanelIndex].tabList[0].component.props.triggerReload = Date.now().toString(); 
        set(multiPanelAtom, newPanelList);
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent',
    },
});

export const triggerReloadHelpdeskTicketByCreateEscalateTicket = selector({
    key: 'triggerReloadHelpdeskTicketByCreateEscalateTicket',
    get: props => ({ get }) => {},
    set: ({ get, set }, data) => {
        let currentPanelList = get(multiPanelAtom);
        let newPanelList = _.cloneDeep(currentPanelList);

        let helpdeskDetailTicketPanels = newPanelList.find(panel => panel.type === data.panelType);

        if (Utils.isEmptyObject(helpdeskDetailTicketPanels)) return;
        const relatedTicketPanel = helpdeskDetailTicketPanels.tabList.find(tab => tab.ticketId === data.parentTicketId);
        relatedTicketPanel.component.props.triggerReload = Date.now().toString();

        set(multiPanelAtom, newPanelList);
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent'
    }
});

export const triggerReloadTab = selector({
    key: 'triggerReloadTab',
    get: (props) =>
        ({ get }) => {
            
        },
    set: ({ get, set }, data) => {
        let currentPanelList = get(multiPanelAtom);
        let newPanelList = _.cloneDeep(currentPanelList);
        let openPanelIndex = newPanelList.findIndex((panel) => panel.type === data.panelType);
        if (openPanelIndex === -1) return;
        let tabList = newPanelList[openPanelIndex].tabList;
        let openChatIndex = tabList.findIndex(tab => tab.id === data.id);
        if (openChatIndex === -1) return;
        newPanelList[openPanelIndex].tabList[openChatIndex].component.props.triggerReload = Date.now().toString();

        set(multiPanelAtom, newPanelList);
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent',
    },
})

/**
 * 
 * @param {*} startPanelIndex current index of slider 
 * @param {*} newPanelList list slider panel
 * @param {*} newPanel new panel push to list
 */
const caculateIndexOpenFromMenu = (startPanelIndex, newPanelList, newPanel) => {
    let insertIndex = 0; // insert index for new panel  newPanelList.splice(startPanelIndex + insertIndex, 0, newPanel);
    let newStartPanelIndex = startPanelIndex; // default current index

    let newPanelListClone = _.cloneDeep(newPanelList);
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);

    const openPanelSize = newPanel.size;
    const startPanelData = newPanelListClone[startPanelIndex];
    const startPanelSize = startPanelData?.size;

    const nextStartPanel = newPanelListClone[startPanelIndex + 1];

    if (newPanel.type === Constant.PANEL_TYPE.OPEN_CHAT_AI) {
        const knowledgeListPanelIndex = newPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
        const knowledgePanel = newPanelList.find(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);
        const knowledgePanelSize = knowledgePanel?.size || Constant.PANEL_SIZE.SIZE_1;

        newStartPanelIndex = knowledgeListPanelIndex + 1;
        insertIndex = 1;

        if ((openPanelSize === Constant.PANEL_SIZE.SIZE_2 && knowledgePanelSize === Constant.PANEL_SIZE.SIZE_1) ||
            (openPanelSize === Constant.PANEL_SIZE.SIZE_1 && knowledgePanelSize === Constant.PANEL_SIZE.SIZE_2)
        ) {
            newStartPanelIndex = knowledgeListPanelIndex
        }

        if (openPanelSize === Constant.PANEL_SIZE.SIZE_1 &&  knowledgePanelSize === Constant.PANEL_SIZE.SIZE_1) {
            newStartPanelIndex = knowledgeListPanelIndex
            if (!newPanelListClone[knowledgeListPanelIndex + 1] &&
                newPanelListClone[knowledgeListPanelIndex - 1] && newPanelListClone[knowledgeListPanelIndex - 1]?.size === Constant.PANEL_SIZE.SIZE_1) {
                newStartPanelIndex = knowledgeListPanelIndex - 1;
            }
        }

        return {insertIndex, newStartPanelIndex}
    }

    // console.log('namnhdebug caculateIndexOpenFromMenu', {newPanelListLength, startPanelIndex, startPanelSize, nextStartPanel, openPanelSize})

    if (newPanelList.length === 0) {
        return {insertIndex, newStartPanelIndex};
    }

    // kiểm tra current view
    if (startPanelSize === Constant.PANEL_SIZE.SIZE_3) {
        // view screen 1 panel 3
        insertIndex = 1;
        newStartPanelIndex = startPanelIndex + 1;
    }

    if (startPanelSize === Constant.PANEL_SIZE.SIZE_2) {
        // view screen 2
        if (!nextStartPanel) {
            insertIndex = 1;
            // view screen 2+1 => startPanelIndex


            // view screen 2+2 || 2+3
            if (openPanelSize !== Constant.PANEL_SIZE.SIZE_1) {
                newStartPanelIndex =  startPanelIndex + 1;
            }
        } else {
             // view screen 2-1
            if (nextStartPanel?.size === Constant.PANEL_SIZE.SIZE_1) {
                insertIndex = 2;
                // view 2-1-2
                if (openPanelSize === Constant.PANEL_SIZE.SIZE_1 || openPanelSize === Constant.PANEL_SIZE.SIZE_2) {
                    newStartPanelIndex = startPanelIndex + 1
                }

                // view 2-1-3
                if (openPanelSize === Constant.PANEL_SIZE.SIZE_3) {
                    newStartPanelIndex = startPanelIndex + 2
                }
               
            } 
            
            // view screen 2-2 || 2-3
            if (nextStartPanel?.size === Constant.PANEL_SIZE.SIZE_2 || nextStartPanel?.size === Constant.PANEL_SIZE.SIZE_3) {
                insertIndex = 1;
               // next screen 2-2-2 || 2-2-3 => focus to open panel
                if (openPanelSize !== Constant.PANEL_SIZE.SIZE_1) {
                    newStartPanelIndex = startPanelIndex + 1
                } 
            }
        }
    }

    if (startPanelSize === Constant.PANEL_SIZE.SIZE_1) {
        // view screen 1
        if (!nextStartPanel) {
            insertIndex = 1;
            // next screent 1-1 1-2 => default view

            // next screen 1-3 => focust to 
            if (openPanelSize === Constant.PANEL_SIZE.SIZE_3) {
                newStartPanelIndex = startPanelIndex + 1
            }
        } else {
             // view screen 1-1
            if (nextStartPanel.size === Constant.PANEL_SIZE.SIZE_1) {
                // next check for 1-1-1
                if (newPanelListClone[startPanelIndex + 2] && newPanelListClone[startPanelIndex + 2]?.size === Constant.PANEL_SIZE.SIZE_1) {
                    insertIndex = 3;
                    
                    switch (openPanelSize) {
                        case Constant.PANEL_SIZE.SIZE_1: // next screen 1-1-1-1
                            newStartPanelIndex = startPanelIndex + 1
                            break;
                        case Constant.PANEL_SIZE.SIZE_2: // next screen 1-1-1-2
                            newStartPanelIndex = startPanelIndex + 2
                            break;
                        case Constant.PANEL_SIZE.SIZE_3: // next screen 1-1-1-3
                            newStartPanelIndex = startPanelIndex + 3
                            break;
                        default:
                            newStartPanelIndex = startPanelIndex + 3
                            break;
                    }
                
                } else {  // default view screen 1-1-2 1-1-3
                    insertIndex = 2;
                    switch (openPanelSize) {
                        case Constant.PANEL_SIZE.SIZE_1: // next screen 1-1-1
                            newStartPanelIndex = startPanelIndex
                            break;
                        case Constant.PANEL_SIZE.SIZE_2: // next screen 1-1-2
                            newStartPanelIndex = startPanelIndex + 1
                            break;
                        case Constant.PANEL_SIZE.SIZE_3: // next screen 1-1-3
                            newStartPanelIndex = startPanelIndex + 2
                            break;
                        default:
                            newStartPanelIndex = startPanelIndex + 2
                            break;
                    }
                  
                }
                
            }

            // view screen 1-2
            if (nextStartPanel.size === Constant.PANEL_SIZE.SIZE_2) {
                insertIndex = 2;
                if (openPanelSize === Constant.PANEL_SIZE.SIZE_1) { // next screen 1-2-1
                    newStartPanelIndex = startPanelIndex + 1
                } else { // next screen 1-2-2 || 1-2-3
                    newStartPanelIndex = startPanelIndex + 2
                }
            }

            // view screen 1-3
            if (nextStartPanel.size === Constant.PANEL_SIZE.SIZE_3) {
                insertIndex = 1;
                if (openPanelSize === Constant.PANEL_SIZE.SIZE_3) { // next screen 1-3-1
                    newStartPanelIndex = startPanelIndex + 1
                } else {
                    newStartPanelIndex = startPanelIndex
                }
            }
        }
       
    }

    return {insertIndex, newStartPanelIndex};

}

/**
 * 
 * @param {*} startPanelIndex 
 * @param {*} newPanelList 
 * @param {*} newPanel 
 * @param {*} fromPanelData 
 */
const caculateIndexOpenFromOtherPanel = (startPanelIndex, newPanelList, newPanel, fromPanelData) => {
    let newPanelListClone = _.cloneDeep(newPanelList);
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);

    const fromPanelIndex = newPanelListClone.findIndex(panel => panel.type === fromPanelData.type);
    const fromPanelSie = fromPanelData?.size || Constant.PANEL_SIZE.SIZE_1

    const openPanelIndex = fromPanelIndex + 1;
    const openPanelSize = newPanel?.size || Constant.PANEL_SIZE.SIZE_1;

    const prevPanelData = newPanelListClone[fromPanelIndex - 1];
    const prevPanelIndex = fromPanelIndex - 1;

    // console.log('namnhdebug caculateIndexOpenFromOtherPanel', {startPanelIndex, fromPanelIndex, prevPanelIndex, fromPanelSie, openPanelSize})

    let newStartPanelIndex = fromPanelIndex; // default focus to from panel open new panel.

    // view 3
    if (fromPanelSie === Constant.PANEL_SIZE.SIZE_3 || openPanelSize === Constant.PANEL_SIZE.SIZE_3) {
        // next view 3-1 3-2 3-3
        newStartPanelIndex = openPanelIndex;
    }

    // view 2 || 1-2 
    if (fromPanelSie === Constant.PANEL_SIZE.SIZE_2) {
        // next view 2-1 || 1-2-1 // default focus 
        // next view 2-2 || 1-2-2 || 2-3 || 1-2-3
        // => so only check openPanelSize != 1 focus to openPanelIndex
        if (openPanelSize !== Constant.PANEL_SIZE.SIZE_1) {
            newStartPanelIndex = openPanelIndex
        }
    }

    if (fromPanelSie === Constant.PANEL_SIZE.SIZE_1) {
        // view 1
        if (!prevPanelData) {
            // next view 1-1 || 1-2 => default focus  fromPanelIndex
            // next view 1-3
            if (openPanelSize === Constant.PANEL_SIZE.SIZE_3) {
                newStartPanelIndex = openPanelIndex
            }
        } else {
            // has prevPanelData => only view 1-1 || 2-1
            if (startPanelIndex === prevPanelIndex) {
                // next view 1-1-1
                if (openPanelSize === Constant.PANEL_SIZE.SIZE_1) {
                    if (prevPanelData?.size === Constant.PANEL_SIZE.SIZE_1) {
                        newStartPanelIndex = startPanelIndex
                    }
                } 
                // next view 1-2-1 => default focus fromPanelIndex
            } 
                // if (prevPanelData?,size === Constant.PANEL_SIZE.SIZE_)
                // if (startPanelIndex === fromPanelIndex)  // cover in default case

                // check special view 1-1-1 and startPanelIndex is the first panel
            if (newPanelListClone[fromPanelIndex - 2] && newPanelListClone[fromPanelIndex - 2]?.size === Constant.PANEL_SIZE.SIZE_1) {
                // next view 1-1-1-1
                if ((fromPanelIndex - 2) === startPanelIndex  && openPanelSize === Constant.PANEL_SIZE.SIZE_1) {
                    newStartPanelIndex = startPanelIndex + 1
                }
            }
            
            
        }
    }


    return {fromPanelIndex, newStartPanelIndex}
}

const getStartPanelIndexOpenNewPanelTablet = (openPanelIndex, newPanelList, newPanel, startPanelIndex, isAddNewPanelFromMenu) => {
    let newPanelListClone = _.cloneDeep(newPanelList);
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);

    const openPanelIndexClone = newPanelListClone.findIndex(panel => panel.type === newPanel.type);
    const prevOpenPanel = newPanelListClone[openPanelIndexClone - 1];
    // console.log('getStartPanelIndexOpenNewPanelTablet', {openPanelIndexClone, isAddNewPanelFromMenu, startPanelIndex})

    
    if (!isAddNewPanelFromMenu) {
        if (openPanelIndexClone === startPanelIndex) {
            return openPanelIndexClone;
        }
        return openPanelIndexClone - 1;
    }

    if (prevOpenPanel) {
        return openPanelIndexClone - 1;
    }
    return openPanelIndexClone;
    
}

const getStartPanelIndexOpenNewPanelMobile = (newPanelList, newPanel) => {
    let newPanelListClone = _.cloneDeep(newPanelList);
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);
   
    const openPanelIndexClone = newPanelListClone.findIndex(panel => panel.type === newPanel.type)

    // if (openPanelIndex >= 0 && newStartPanelIndex !== openPanelIndexClone) {
    //     newStartPanelIndex = openPanelIndexClone;
    // } else {
    //     newStartPanelIndex = openPanelIndexClone;
    // }
    return openPanelIndexClone;
}


/**
 * removeTabAndPanel
 * function support remove tab and panel from workspace
 * @param {*} panelList 
 * @param {*} panelType 
 * @param {*} tabId 
 * @returns 
 */
const removeTabAndPanel = (panelList, panelType, tabId, isRemovePanel = true) => {
    let newPanelList = _.cloneDeep(panelList);
    let panelIndex = newPanelList.findIndex((panel) => panel.type === panelType);
    let tabIndex = newPanelList[panelIndex]?.tabList?.findIndex((tab) => tab.id === tabId);
    if (panelIndex === -1 || tabIndex === -1) {
        return newPanelList
    };

    let activeTab = newPanelList[panelIndex]?.activeTab;

    // check case close tab setting chatbot then close panel preview chatbot
    let infoTab = newPanelList[panelIndex]?.tabList[tabIndex];
    if(infoTab?.id === Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT) {
        let indexPanelRelated = newPanelList.findIndex(
            p => p.type === Constant.PANEL_TYPE.PREVIEW_CHATBOT
        );
        if (indexPanelRelated !== -1 && isRemovePanel) {
            newPanelList.splice(indexPanelRelated, 1);
        }
    }

    //case close create ticket knowledge tab then close upload csv
    if (
        infoTab?.id.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_CREATE_TICKET) ||
        infoTab?.component?.props?.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT
    ) {
        let indexPanelRelated = newPanelList.findIndex(
            p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
        );
        if (indexPanelRelated !== -1) {
            let infoPanelUploadCsv = newPanelList[indexPanelRelated];
            if (infoPanelUploadCsv.tabList[0]?.id === infoTab?.id && isRemovePanel) {
                newPanelList.splice(indexPanelRelated, 1);
            }
        }
    }

    newPanelList[panelIndex]?.tabList?.splice(tabIndex, 1);
    if(tabIndex === activeTab && newPanelList[panelIndex]){
        if(tabIndex === 0){
            if(newPanelList[panelIndex].tabList.length){
                newPanelList[panelIndex].activeTab = 0;
            }else if (isRemovePanel){
                newPanelList.splice(panelIndex, 1);
            }
        }else{
            newPanelList[panelIndex].activeTab = tabIndex - 1;
        }
    }else {
        if(tabIndex < activeTab){
            newPanelList[panelIndex].activeTab = activeTab - 1;
        }
    }
    
    if(newPanelList[panelIndex] && Utils.isEmptyArray(newPanelList[panelIndex]?.tabList) && isRemovePanel) {
        newPanelList.splice(panelIndex, 1);
    }

    return newPanelList;
}


export const updateParamIsCustomerKnowledgeDrilldown = selector({
    key: 'updateParamIsCustomerKnowledgeDrilldown',
    get: (props) =>
        ({ get }) => {
            
        },
    set: ({ get, set }, data) => {
        let currentPanelList = get(multiPanelAtom);
        let newPanelList = _.cloneDeep(currentPanelList);
        let openPanelIndex = newPanelList.findIndex((panel) => [Constant.PANEL_TYPE.KNOWLEDGE_PRJ_INUSE_DRILLDOWN_AND_DETAIL_SEARCH, Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_DRILLDOWN_AND_DETAIL_SEARCH].includes(panel.type));
        if (openPanelIndex === -1) return;

        newPanelList[openPanelIndex].tabList[0].component.props.isCustomer = data.isCustomer ? data.isCustomer : false;
        
        set(multiPanelAtom, newPanelList);
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent',
    },
})
